import { useRemoveCartItems } from '@/features/cart/hooks/useRemoveCartItems'
import { useUpdateCart } from '@/features/cart/hooks/useUpdateCart'
import { IconButton, Icon } from '@lounge-fe/ui-kit'
import { BasketLineRemoveButtonProps } from './types'
import { t } from 'i18next'

export const RemoveButton = ({ lineItemKeys }: BasketLineRemoveButtonProps) => {
  const removeItems = useRemoveCartItems()
  const update = useUpdateCart()

  return (
    <IconButton
      icon={<Icon.Trash className="w-3 h-3" />}
      variant="ghost"
      size="sm"
      aria-label={t('action.remove')}
      onClick={() =>
        removeItems.mutate(
          lineItemKeys.flatMap((key) => (Array.isArray(key) ? [...key] : key)),
        )
      }
    />
  )
}
